<template>
  <div class="container mx-auto">
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4">
        <CCard class="pb-3">
          <CCardHeader class="d-flex justify-content-between">
            <span><i class="fas fa-store"></i>&nbsp;Venta</span>
            <button
              @click="returnHome"
              type="button"
              class="btn btn-sm text-white"
              style="background: #e46666"
            >
              <i class="fas fa-hand-point-left"></i> Retroceder
            </button>
          </CCardHeader>
          <template v-if="popularProducts.length > 0">
            <CCardBody
              v-for="(item, index) in popularProducts"
              :key="index"
              class="container-card-body mt-3 mx-3"
              @click="addPopularProduct(item)"
              :class="item.stock == 0 ? '' : 'bg-info'"
            >
              <CRow>
                <CCol
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  class="d-flex justify-content-between font-bold"
                >
                  <div>{{ item.label }}</div>
                  <div>Precio: {{ item.price }}</div>
                </CCol>
              </CRow>
            </CCardBody>
          </template>
          <template v-else>
            <CCardBody class="text-center">
              <h4>AUN NO CUENTA CON PRODUCTOS VENDIDOS</h4>
            </CCardBody>
          </template>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="8">
        <CCard>
          <CCardHeader class="d-flex justify-content-between responsive">
            <span><i class="fas fa-coins"></i>&nbsp;Producto</span>
            <div class="d-flex flex-wrap">
              <div class="font-bold responsive-font mr-lg-3 mr-md-2 mr-sm-1">
                <b>Total S/{{ calculateTotal.toFixed(2) }}</b>
              </div>
              <button
                type="button"
                class="btn btn-sm text-white"
                style="background: #39f; margin-right: 10px"
                @click="mtdOpenModalSale"
              >
                <i class="fas fa-dollar-sign"></i>
                <b>Terminar Venta</b>
              </button>
              <button
                type="button"
                class="btn btn-sm text-white"
                style="background: #30d5c8"
                @click="mtdOpenQuotes"
              >
                <i class="fas fa-dollar-sign"></i>
                <b>Cotizacion</b>
              </button>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="6" lg="6">
                <CInput
                  label="Código de Producto"
                  placeholder="Digite de barras mediante la lectora"
                  v-model="searchBarcode"
                  @keypress.enter="filterProductoBarcode"
                />
              </CCol>
              <CCol xs="12" sm="12" md="6" lg="6">
                <CInput
                  label="Buscar Producto"
                  type="search"
                  v-model="searchQuery"
                  @keypress.enter="filterProducts"
                  placeholder="Digite nombre de producto.."
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardHeader class="d-flex justify-content-start">
            <span><i class="fa fa-store"></i>&nbsp; Detalle de venta </span>
          </CCardHeader>
          <CCardBody>
            <div class="table-responsive">
              <table
                id="dataTableLists"
                class="table table-sm table-hover table-bordered dt-responsive nowrap"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th width="60">N°</th>
                    <th>Producto</th>
                    <th>Unidad</th>
                    <th>Stock</th>
                    <th>Precio</th>
                    <th>Cantidad</th>
                    <th>Subtotal</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(product, index) in productList"
                    :key="index"
                    @click="openProductModal(product)"
                    style="cursor: pointer"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ product.product.name }}</td>
                    <td>{{ product.unit.name }}</td>
                    <td>
                      {{
                        product.stock ? parseInt(product.stock) : product.stock
                      }}
                    </td>
                    <td>{{ product.price }}</td>
                    <td>{{ product.quantity }}</td>
                    <td>{{ (product.price * product.quantity).toFixed(2) }}</td>
                    <td>
                      <button
                        @click.stop="removeProduct(index)"
                        class="btn btn-danger btn-sm"
                      >
                        <i class="fas fa-trash"></i> Eliminar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <div class="container mx-auto p-4">
      <!-- Existing content -->
      <cModalSale
        :title="modalSale.title"
        :productList="productList"
        :sale="sale"
        :boo_modal="modalSale.modal_form"
        @closeModalSale="closeModalSale"
        @save="handleSave"
      />

      <cModalUpdateSale
        :title="modalUpdateSale.title"
        :boo_modal="modalUpdateSale.modal_form"
        :product="modalUpdateSale.product"
        @closeModalUpdateSale="closeModalUpdateSale"
        @updateProduct="handleUpdateProduct"
      />

      <cModalProductList
        :products="filteredProducts"
        :boo_modal="modalProductList.modal_form"
        @close="closeProductListModal"
        @selectProduct="selectProduct"
        @mtdGetDeslozar="mtdGetDeslozar"
      />

      <CModalDeslozar
        :units="unitToDeslozar"
        :stock="stockDisponibleADeslozar"
        :boo_modal="modalDeslozar.modal_form"
        :title="modalDeslozar.title"
        @close="closeDeslozarModal"
        @mtdCommitDeslozar="mtdCommitDeslozar"
      />

      <cModalQuotes
        ref="cQuotes"
        :title="modalQuotes.title"
        :boo_modal="modalQuotes.modal_form"
        :sale="sale"
        @mtdClose="closeModalQuotes"
        @save="saveQuotes"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import cModalSale from "../modals/cModalSale.vue";
import cModalUpdateSale from "../modals/cModalUpdateSale.vue";
import cModalProductList from "../modals/cModalProductList.vue";
import cModalQuotes from "../modals/cModalQuotes.vue";
import CModalDeslozar from "../modals/cModalDeslozar.vue";

export default {
  name: "sales",
  components: {
    cModalSale,
    cModalUpdateSale,
    cModalProductList,
    cModalQuotes,
    CModalDeslozar,
  },
  data() {
    return {
      prefix: "sales",
      data_product: [],
      estado: true,
      searchQuery: "", // Para almacenar lo que escribe el usuario
      searchBarcode: "", // Para almacenar lo que escribe el usuario
      filteredProducts: [], // Para almacenar los productos filtrados
      filteredProductsBarcode: [], // Para almacenar los productos filtrados
      productList: [],
      popularProducts: [],
      sale: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        document_type_id: "",
        date: "",
        method: "",
        type: "",
        total: 0 /** monto total del servicio */,
        amount: 0 /**monto pagado - adelanto */,
        pending: 0 /** pendiente */,
        ruc: "",
        state: 0,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        typeAjustment: 0 /** tipo de ajuste % o S/ */,
        adjustment: 0 /** monto de ajuste */,
        new_pending: "" /** pendiente luego del ajuste */,
        pendigPayment: 0,
        option: 0,
      },
      newProduct: {
        product: {
          id: "",
          name: "",
        },
        price: "",
        quantity: 1,
        subtotal: 0,
        stock: 0,
      },
      modalSale: {
        title: "Terminar Venta",
        modal_form: false,
      },
      modalUpdateSale: {
        title: "Editar",
        modal_form: false,
        product: {
          product: {
            id: "",
            name: "",
          },
          price: "",
          quantity: "",
          subtotal: "",
        },
      },
      modalProductList: {
        modal_form: false,
      },
      modalQuotes: {
        title: "COTIZACIÓN",
        modal_form: false,
      },
      /** deslozar */
      lastSearch: "",
      unitToDeslozar: [],
      stockDisponibleADeslozar: {},
      modalDeslozar: {
        title: "DESLOZAR UNIDADES",
        modal_form: false,
      },
    };
  },
  computed: {
    calculateSubtotal() {
      return (this.newProduct.subtotal =
        this.newProduct.price * this.newProduct.quantity);
    },
    calculateTotal() {
      return this.productList.reduce((total, product) => {
        return total + product.price * product.quantity;
      }, 0);
    },
    cpButton() {},
  },
  watch: {
    productList: {
      handler() {
        this.sale.total = this.calculateTotal.toFixed(2);
      },
      deep: true,
    },
  },
  created() {
    this.showProduct();
    this.showPopularProducts();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    showPopularProducts() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byPopularProducts/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          const stockMap = new Map();

          // Mapeo de stock por product_unit_id para acceso rápido
          response.data.stock.forEach(({ product_unit, stock }) => {
            stockMap.set(product_unit.id, {
              productName: product_unit.product.name,
              productId: product_unit.product.id,
              unitName: product_unit.unit.name,
              unitId: product_unit.unit.id,
              price: product_unit.product.price[0].sale_price,
              stock: stock,
            });
          });

          // Construcción de popularProducts combinando la información del stock y popular
          response.data.popular.forEach(
            ({ product_unit_id, total_quantity }, index) => {
              if (index < 7) {
                const stockInfo = stockMap.get(product_unit_id);
                if (stockInfo) {
                  this.popularProducts.push({
                    label: stockInfo.productName,
                    value: stockInfo.productId,
                    label_unit: stockInfo.unitName,
                    value_unit: stockInfo.unitId,
                    price: stockInfo.price,
                    quantity: total_quantity,
                    stock: stockInfo.stock,
                  });
                }
              }
            }
          );
          this.popularProducts = this.popularProducts.slice(0, 7);
        })
        .catch((errors) => {});
    },
    showProduct() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/carbino/byProduct/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            // limpiar arreglo
            this.data_product = [];
            response.data.data.forEach((arr) => {
              const { product_unit, stock, sale_price } = arr;
              this.data_product.push({
                label: product_unit.product.name,
                value: product_unit.product.id,
                price: sale_price,
                value_unit: product_unit.unit.id,
                label_unit: product_unit.unit.name,
                barcodes: product_unit.product.barcode,
                stock: stock,
              });
            });
          }
        })
        .catch((errors) => {});
    },
    filterProducts() {
      if (this.searchQuery) {
        this.lastSearch = this.searchQuery;
        this.filteredProducts = this.data_product.filter((product) =>
          product.label.toLowerCase().includes(this.searchQuery.toLowerCase())
        );

        if (this.filteredProducts.length > 0) {
          this.modalProductList.modal_form = true;
        }
      }
    },
    filterProductsAfterDeslozar() {
      if (this.lastSearch) {
        this.filteredProducts = this.data_product.filter((product) =>
          product.label.toLowerCase().includes(this.lastSearch.toLowerCase())
        );

        if (this.filteredProducts.length > 0) {
          this.modalProductList.modal_form = true;
        }
      }
    },
    selectProduct(product) {
      this.searchQuery = "";
      const existingProduct = this.productList.find(
        (p) =>
          p.product.id === product.value && p.unit.id === product.value_unit
      );

      if (existingProduct) {
        // If the product exists, increment its quantity
        existingProduct.quantity += 1;
      } else {
        // If the product doesn't exist, add it to the list
        const newProduct = {
          product: {
            id: product.value,
            name: product.label,
          },
          unit: {
            id: product.value_unit,
            name: product.label_unit,
          },
          price: product.price,
          quantity: 1,
          subtotal: product.price,
          stock: product.stock,
        };
        this.productList.push(newProduct);
      }

      // Close the modal after selection
      this.closeProductListModal();
    },
    closeProductListModal() {
      this.modalProductList.modal_form = false;
    },
    removeProduct(index) {
      // this.productList.splice(index, 1);
      Swal.fire({
        title: "¿Desea eliminar el producto?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          // Si el usuario confirma, se elimina el producto
          this.productList.splice(index, 1);
          Swal.fire("Eliminado!", "El producto ha sido eliminado.", "success");
        }
      });
    },
    addPopularProduct(item) {
      const existingProduct = this.productList.find(
        (product) => product.product.name === item.label
      );

      if (existingProduct) {
        // If the product exists, increment the quantity
        existingProduct.quantity += 1;
      } else {
        // If the product doesn't exist, add it to the list
        const productToAdd = {
          product: {
            id: item.value, // Use item.value for the ID
            name: item.label,
          },
          unit: {
            id: item.value_unit,
            name: item.label_unit,
          },
          price: item.price,
          quantity: 1,
          subtotal: item.price,
          stock: item.stock,
        };
        this.productList.push(productToAdd);
      }
    },
    // Existing methods
    handleSave() {
      // Restablecer la lista de productos y la venta después de guardar
      this.productList = [];
      this.sale = {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        document_type_id: "",
        date: "",
        method: "",
        type: "",
        total: 0 /** monto total del servicio */,
        amount: 0 /**monto pagado - adelanto */,
        pending: 0 /** pendiente */,
        ruc: "",
        state: 0,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        typeAjustment: 0 /** tipo de ajuste % o S/ */,
        adjustment: 0 /** monto de ajuste */,
        new_pending: "" /** pendiente luego del ajuste */,
        pendigPayment: 0,
        option: 0,
      };
      this.modalSale.modal_form = false;

      //limpio datos
      this.data_product = [];
      this.popularProducts = [];
      //recargo denuevo
      this.showProduct();
      this.showPopularProducts();
    },
    mtdOpenModalSale() {
      this.modalSale = {
        title: "TERMINAR VENTA",
        modal_form: true,
      };
    },
    closeModalSale() {
      this.modalSale = {
        modal_form: false,
      };
      this.sale.entity_document = "";
      this.sale.entity_name = "";
    },
    openProductModal(product) {
      this.modalUpdateSale = {
        title: "Editar",
        modal_form: true,
        product: product,
      };
    },
    closeModalUpdateSale() {
      this.modalUpdateSale = {
        modal_form: false,
      };
    },
    handleUpdateProduct(updatedProduct) {
      const index = this.productList.findIndex(
        (p) => p.product.id === updatedProduct.product.id
      );
      if (index !== -1) {
        this.$set(this.productList, index, updatedProduct); // Actualiza el producto en la lista
      }
    },
    filterProductoBarcode() {
      if (this.searchBarcode) {
        // Filtrar los productos que coinciden con el código de barras
        this.filteredProductsBarcode = this.data_product.filter((product) =>
          product.barcodes.some(
            (barcode) => barcode.name === this.searchBarcode
          )
        );

        // Si se encuentran productos coincidentes, ejecutar la función para agregarlos
        if (this.filteredProductsBarcode.length > 0) {
          this.addProductoBarcode(this.filteredProductsBarcode);
        } else {
          Swal.fire({
            title: "Código de barra no encontrada",
            icon: "warning",
          });
        }
      }
    },
    addProductoBarcode(product) {
      const prod = product[0];
      const existingProduct = this.productList.find(
        (p) => p.product.id === prod.value && p.unit.id === prod.value_unit
      );

      if (existingProduct) {
        existingProduct.quantity += 1;
      } else {
        // If the product doesn't exist, add it to the list
        const newProduct = {
          product: {
            id: prod.value,
            name: prod.label,
          },
          unit: {
            id: prod.value_unit,
            name: prod.label_unit,
          },
          price: prod.price,
          quantity: 1,
          subtotal: prod.price,
          stock: prod.stock,
        };
        this.productList.push(newProduct);
      }
    },
    //Cotizacion
    mtdOpenQuotes() {
      if (this.productList.length == 0) {
        Swal.fire({
          title: "Agregue un Producto al Carrito",
          icon: "warning",
        });
      } else {
        this.modalQuotes = {
          title: "COTIZACIÓN",
          modal_form: true,
        };
      }
    },
    closeModalQuotes() {
      this.modalQuotes = {
        title: "COTIZACIÓN",
        modal_form: false,
      };
    },
    saveQuotes(data, total, pagoTotal) {
      this.post({
        url: this.$store.getters.get__url + "/quotes/store",
        token: this.$store.getters.get__token,
        params: {
          data: data,
          total: total,
          pagoTotal: pagoTotal,
          products: this.productList,
          company_id: this.$store.getters.get_company.id,
          campu_id: this.$store.getters.get_campu.id,
          user_id: this.$store.getters.get__user_id,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            Swal.fire({
              title: "Registrado Correctamente",
              icon: "success",
            });
            this.viewpdfQuotes(response.data.id);
            this.productList = [];
            this.$nextTick(() => {
              if (this.$refs.cQuotes && this.$refs.cQuotes.mtdClear) {
                this.$refs.cQuotes.mtdClear();
              }
            });
            this.closeModalQuotes();
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "error",
          });
        });
    },
    viewpdfQuotes: function (id) {
      window.open(
        this.$store.getters.get__url + "/viewpdfQuotes/" + id,
        "_blank"
      );
    },
    /** deslozar */
    mtdGetDeslozar: function (payload) {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/deslozar/getunit",
        token: this.$store.getters.get__token,
        params: payload,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.unitToDeslozar = response.data.unitADeslozar;
            this.stockDisponibleADeslozar = response.data.stockDisponible;
            this.modalDeslozar = {
              title: "DESLOZAR UNIDADES DE: " + payload.label,
              modal_form: true,
            };
            this.closeProductListModal();
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "error",
          });
        });
    },
    closeDeslozarModal: function () {
      this.modalDeslozar = {
        title: "DESLOZAR UNIDADES DE",
        modal_form: false,
      };
      this.unitToDeslozar = [];
      this.stockDisponibleADeslozar = {};
    },
    mtdCommitDeslozar: function (payload) {
      this.post({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/deslozar/commit",
        token: this.$store.getters.get__token,
        params: {
          a_unidad: payload.a_unit.id,
          quantity: payload.quantity,
          desde_stock: this.stockDisponibleADeslozar.id,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.showProduct();
            this.closeDeslozarModal();
            setTimeout(() => {
              this.filterProductsAfterDeslozar();
              console.log("Ejecutado después de 1 segundo");
            }, 1000);
            Swal.fire({
              title: "Deslozado correctamente!",
              icon: "success",
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.bg-purple {
  background-color: #926cdc;
}

.bg-white {
  background-color: white;
}

.bg-gris {
  background-color: #dee2e6;
}

.bg-gray {
  background-color: #dee2e6;
}

.bg-green {
  background-color: #28a745;
}

.color-white {
  color: white;
}

.color-black {
  color: black;
}

.font-bold {
  font-weight: bold;
}

.container-card-body {
  background-color: #dee2e6;
  border-radius: 8px;
  cursor: pointer;
}

.lista {
  background-color: #ebedef;
  border-radius: 6px;
  width: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin-top: -10px;
}

.lista li {
  width: 100%;
  padding: 2px 0 2px 10px;
}

.lista li:hover {
  border-radius: 6px;
  background-color: #39f;
  list-style-type: none;
  color: #fff;
}

.table-responsive {
  overflow-x: auto;
}

.responsive-font {
  font-size: 1rem;
}

.responsive {
  flex-direction: row;
}

@media (min-width: 300px) {
  /* sm */
  .responsive {
    flex-direction: column;
  }
}

@media (min-width: 576px) {
  /* sm */
  .responsive-font {
    font-size: 1.25rem;
  }
}

@media (min-width: 768px) {
  /* md */
  .responsive-font {
    font-size: 1.4rem;
  }

  .responsive {
    flex-direction: row;
  }
}

@media (min-width: 992px) {
  /* lg */
  .responsive-font {
    font-size: 1.4rem;
  }
}
</style>
